export default __webpack_public_path__ + "static/media/Blacksulphur Gloves.42573026.jpg";